export default "__VITE_ASSET__BjyOgQAh__"